import { render } from "./Tools.vue?vue&type=template&id=67b674d4&scoped=true"
import script from "./Tools.vue?vue&type=script&lang=js"
export * from "./Tools.vue?vue&type=script&lang=js"

import "./Tools.vue?vue&type=style&index=0&id=67b674d4&lang=scss&scoped=true"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b674d4"]])

export default __exports__